/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createOneBaseMgmtShipperControllerShipperCompany } from '../fn/shipper/create-one-base-mgmt-shipper-controller-shipper-company';
import { CreateOneBaseMgmtShipperControllerShipperCompany$Params } from '../fn/shipper/create-one-base-mgmt-shipper-controller-shipper-company';
import { createOneBaseMgmtShipperTargetControllerShipperTarget } from '../fn/shipper/create-one-base-mgmt-shipper-target-controller-shipper-target';
import { CreateOneBaseMgmtShipperTargetControllerShipperTarget$Params } from '../fn/shipper/create-one-base-mgmt-shipper-target-controller-shipper-target';
import { deleteOneBaseMgmtShipperControllerShipperCompany } from '../fn/shipper/delete-one-base-mgmt-shipper-controller-shipper-company';
import { DeleteOneBaseMgmtShipperControllerShipperCompany$Params } from '../fn/shipper/delete-one-base-mgmt-shipper-controller-shipper-company';
import { deleteOneBaseMgmtShipperTargetControllerShipperTarget } from '../fn/shipper/delete-one-base-mgmt-shipper-target-controller-shipper-target';
import { DeleteOneBaseMgmtShipperTargetControllerShipperTarget$Params } from '../fn/shipper/delete-one-base-mgmt-shipper-target-controller-shipper-target';
import { getManyBaseMgmtShipperControllerShipperCompany } from '../fn/shipper/get-many-base-mgmt-shipper-controller-shipper-company';
import { GetManyBaseMgmtShipperControllerShipperCompany$Params } from '../fn/shipper/get-many-base-mgmt-shipper-controller-shipper-company';
import { getManyBaseMgmtShipperTargetControllerShipperTarget } from '../fn/shipper/get-many-base-mgmt-shipper-target-controller-shipper-target';
import { GetManyBaseMgmtShipperTargetControllerShipperTarget$Params } from '../fn/shipper/get-many-base-mgmt-shipper-target-controller-shipper-target';
import { GetManyShipperCompanyResponseDto } from '../models/get-many-shipper-company-response-dto';
import { GetManyShipperTargetResponseDto } from '../models/get-many-shipper-target-response-dto';
import { getOneBaseMgmtShipperControllerShipperCompany } from '../fn/shipper/get-one-base-mgmt-shipper-controller-shipper-company';
import { GetOneBaseMgmtShipperControllerShipperCompany$Params } from '../fn/shipper/get-one-base-mgmt-shipper-controller-shipper-company';
import { getOneBaseMgmtShipperTargetControllerShipperTarget } from '../fn/shipper/get-one-base-mgmt-shipper-target-controller-shipper-target';
import { GetOneBaseMgmtShipperTargetControllerShipperTarget$Params } from '../fn/shipper/get-one-base-mgmt-shipper-target-controller-shipper-target';
import { mgmtShipperControllerGetLegacyShipperCountries } from '../fn/shipper/mgmt-shipper-controller-get-legacy-shipper-countries';
import { MgmtShipperControllerGetLegacyShipperCountries$Params } from '../fn/shipper/mgmt-shipper-controller-get-legacy-shipper-countries';
import { mgmtShipperControllerGetLegacyShippers } from '../fn/shipper/mgmt-shipper-controller-get-legacy-shippers';
import { MgmtShipperControllerGetLegacyShippers$Params } from '../fn/shipper/mgmt-shipper-controller-get-legacy-shippers';
import { Shipper } from '../models/shipper';
import { ShipperCompany } from '../models/shipper-company';
import { ShipperCountry } from '../models/shipper-country';
import { ShipperTarget } from '../models/shipper-target';
import { updateOneBaseMgmtShipperControllerShipperCompany } from '../fn/shipper/update-one-base-mgmt-shipper-controller-shipper-company';
import { UpdateOneBaseMgmtShipperControllerShipperCompany$Params } from '../fn/shipper/update-one-base-mgmt-shipper-controller-shipper-company';
import { updateOneBaseMgmtShipperTargetControllerShipperTarget } from '../fn/shipper/update-one-base-mgmt-shipper-target-controller-shipper-target';
import { UpdateOneBaseMgmtShipperTargetControllerShipperTarget$Params } from '../fn/shipper/update-one-base-mgmt-shipper-target-controller-shipper-target';

@Injectable({ providedIn: 'root' })
export class ShipperApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `mgmtShipperControllerGetLegacyShippers()` */
  static readonly MgmtShipperControllerGetLegacyShippersPath = '/api/mgmt/shippers/legacy-shippers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mgmtShipperControllerGetLegacyShippers()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtShipperControllerGetLegacyShippers$Response(params?: MgmtShipperControllerGetLegacyShippers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Shipper>>> {
    const obs = mgmtShipperControllerGetLegacyShippers(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mgmtShipperControllerGetLegacyShippers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtShipperControllerGetLegacyShippers(params?: MgmtShipperControllerGetLegacyShippers$Params, context?: HttpContext): Observable<Array<Shipper>> {
    const resp = this.mgmtShipperControllerGetLegacyShippers$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Shipper>>): Array<Shipper> => r.body)
    );
  }

  /** Path part for operation `mgmtShipperControllerGetLegacyShipperCountries()` */
  static readonly MgmtShipperControllerGetLegacyShipperCountriesPath = '/api/mgmt/shippers/legacy-shippers-countries';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mgmtShipperControllerGetLegacyShipperCountries()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtShipperControllerGetLegacyShipperCountries$Response(params: MgmtShipperControllerGetLegacyShipperCountries$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ShipperCountry>>> {
    const obs = mgmtShipperControllerGetLegacyShipperCountries(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mgmtShipperControllerGetLegacyShipperCountries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtShipperControllerGetLegacyShipperCountries(params: MgmtShipperControllerGetLegacyShipperCountries$Params, context?: HttpContext): Observable<Array<ShipperCountry>> {
    const resp = this.mgmtShipperControllerGetLegacyShipperCountries$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ShipperCountry>>): Array<ShipperCountry> => r.body)
    );
  }

  /** Path part for operation `getManyBaseMgmtShipperControllerShipperCompany()` */
  static readonly GetManyBaseMgmtShipperControllerShipperCompanyPath = '/api/mgmt/shippers';

  /**
   * Retrieve multiple ShipperCompanies.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtShipperControllerShipperCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtShipperControllerShipperCompany$Response(params?: GetManyBaseMgmtShipperControllerShipperCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyShipperCompanyResponseDto>> {
    const obs = getManyBaseMgmtShipperControllerShipperCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple ShipperCompanies.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtShipperControllerShipperCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtShipperControllerShipperCompany(params?: GetManyBaseMgmtShipperControllerShipperCompany$Params, context?: HttpContext): Observable<GetManyShipperCompanyResponseDto> {
    const resp = this.getManyBaseMgmtShipperControllerShipperCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyShipperCompanyResponseDto>): GetManyShipperCompanyResponseDto => r.body)
    );
  }

  /** Path part for operation `createOneBaseMgmtShipperControllerShipperCompany()` */
  static readonly CreateOneBaseMgmtShipperControllerShipperCompanyPath = '/api/mgmt/shippers';

  /**
   * Create a single ShipperCompany.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOneBaseMgmtShipperControllerShipperCompany()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtShipperControllerShipperCompany$Response(params: CreateOneBaseMgmtShipperControllerShipperCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<ShipperCompany>> {
    const obs = createOneBaseMgmtShipperControllerShipperCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a single ShipperCompany.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOneBaseMgmtShipperControllerShipperCompany$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtShipperControllerShipperCompany(params: CreateOneBaseMgmtShipperControllerShipperCompany$Params, context?: HttpContext): Observable<ShipperCompany> {
    const resp = this.createOneBaseMgmtShipperControllerShipperCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShipperCompany>): ShipperCompany => r.body)
    );
  }

  /** Path part for operation `getOneBaseMgmtShipperControllerShipperCompany()` */
  static readonly GetOneBaseMgmtShipperControllerShipperCompanyPath = '/api/mgmt/shippers/{id}';

  /**
   * Retrieve a single ShipperCompany.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMgmtShipperControllerShipperCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtShipperControllerShipperCompany$Response(params: GetOneBaseMgmtShipperControllerShipperCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<ShipperCompany>> {
    const obs = getOneBaseMgmtShipperControllerShipperCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single ShipperCompany.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMgmtShipperControllerShipperCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtShipperControllerShipperCompany(params: GetOneBaseMgmtShipperControllerShipperCompany$Params, context?: HttpContext): Observable<ShipperCompany> {
    const resp = this.getOneBaseMgmtShipperControllerShipperCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShipperCompany>): ShipperCompany => r.body)
    );
  }

  /** Path part for operation `deleteOneBaseMgmtShipperControllerShipperCompany()` */
  static readonly DeleteOneBaseMgmtShipperControllerShipperCompanyPath = '/api/mgmt/shippers/{id}';

  /**
   * Delete a single ShipperCompany.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOneBaseMgmtShipperControllerShipperCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtShipperControllerShipperCompany$Response(params: DeleteOneBaseMgmtShipperControllerShipperCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteOneBaseMgmtShipperControllerShipperCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a single ShipperCompany.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOneBaseMgmtShipperControllerShipperCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtShipperControllerShipperCompany(params: DeleteOneBaseMgmtShipperControllerShipperCompany$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteOneBaseMgmtShipperControllerShipperCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateOneBaseMgmtShipperControllerShipperCompany()` */
  static readonly UpdateOneBaseMgmtShipperControllerShipperCompanyPath = '/api/mgmt/shippers/{id}';

  /**
   * Update a single ShipperCompany.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOneBaseMgmtShipperControllerShipperCompany()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtShipperControllerShipperCompany$Response(params: UpdateOneBaseMgmtShipperControllerShipperCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<ShipperCompany>> {
    const obs = updateOneBaseMgmtShipperControllerShipperCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a single ShipperCompany.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOneBaseMgmtShipperControllerShipperCompany$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtShipperControllerShipperCompany(params: UpdateOneBaseMgmtShipperControllerShipperCompany$Params, context?: HttpContext): Observable<ShipperCompany> {
    const resp = this.updateOneBaseMgmtShipperControllerShipperCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShipperCompany>): ShipperCompany => r.body)
    );
  }

  /** Path part for operation `getManyBaseMgmtShipperTargetControllerShipperTarget()` */
  static readonly GetManyBaseMgmtShipperTargetControllerShipperTargetPath = '/api/mgmt/shipper/{shipperId}/targets';

  /**
   * Retrieve multiple ShipperTargets.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtShipperTargetControllerShipperTarget()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtShipperTargetControllerShipperTarget$Response(params: GetManyBaseMgmtShipperTargetControllerShipperTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyShipperTargetResponseDto>> {
    const obs = getManyBaseMgmtShipperTargetControllerShipperTarget(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple ShipperTargets.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtShipperTargetControllerShipperTarget$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtShipperTargetControllerShipperTarget(params: GetManyBaseMgmtShipperTargetControllerShipperTarget$Params, context?: HttpContext): Observable<GetManyShipperTargetResponseDto> {
    const resp = this.getManyBaseMgmtShipperTargetControllerShipperTarget$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyShipperTargetResponseDto>): GetManyShipperTargetResponseDto => r.body)
    );
  }

  /** Path part for operation `createOneBaseMgmtShipperTargetControllerShipperTarget()` */
  static readonly CreateOneBaseMgmtShipperTargetControllerShipperTargetPath = '/api/mgmt/shipper/{shipperId}/targets';

  /**
   * Create a single ShipperTarget.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOneBaseMgmtShipperTargetControllerShipperTarget()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtShipperTargetControllerShipperTarget$Response(params: CreateOneBaseMgmtShipperTargetControllerShipperTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<ShipperTarget>> {
    const obs = createOneBaseMgmtShipperTargetControllerShipperTarget(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a single ShipperTarget.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOneBaseMgmtShipperTargetControllerShipperTarget$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtShipperTargetControllerShipperTarget(params: CreateOneBaseMgmtShipperTargetControllerShipperTarget$Params, context?: HttpContext): Observable<ShipperTarget> {
    const resp = this.createOneBaseMgmtShipperTargetControllerShipperTarget$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShipperTarget>): ShipperTarget => r.body)
    );
  }

  /** Path part for operation `getOneBaseMgmtShipperTargetControllerShipperTarget()` */
  static readonly GetOneBaseMgmtShipperTargetControllerShipperTargetPath = '/api/mgmt/shipper/{shipperId}/targets/{id}';

  /**
   * Retrieve a single ShipperTarget.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMgmtShipperTargetControllerShipperTarget()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtShipperTargetControllerShipperTarget$Response(params: GetOneBaseMgmtShipperTargetControllerShipperTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<ShipperTarget>> {
    const obs = getOneBaseMgmtShipperTargetControllerShipperTarget(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single ShipperTarget.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMgmtShipperTargetControllerShipperTarget$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtShipperTargetControllerShipperTarget(params: GetOneBaseMgmtShipperTargetControllerShipperTarget$Params, context?: HttpContext): Observable<ShipperTarget> {
    const resp = this.getOneBaseMgmtShipperTargetControllerShipperTarget$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShipperTarget>): ShipperTarget => r.body)
    );
  }

  /** Path part for operation `deleteOneBaseMgmtShipperTargetControllerShipperTarget()` */
  static readonly DeleteOneBaseMgmtShipperTargetControllerShipperTargetPath = '/api/mgmt/shipper/{shipperId}/targets/{id}';

  /**
   * Delete a single ShipperTarget.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOneBaseMgmtShipperTargetControllerShipperTarget()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtShipperTargetControllerShipperTarget$Response(params: DeleteOneBaseMgmtShipperTargetControllerShipperTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteOneBaseMgmtShipperTargetControllerShipperTarget(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a single ShipperTarget.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOneBaseMgmtShipperTargetControllerShipperTarget$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtShipperTargetControllerShipperTarget(params: DeleteOneBaseMgmtShipperTargetControllerShipperTarget$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteOneBaseMgmtShipperTargetControllerShipperTarget$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateOneBaseMgmtShipperTargetControllerShipperTarget()` */
  static readonly UpdateOneBaseMgmtShipperTargetControllerShipperTargetPath = '/api/mgmt/shipper/{shipperId}/targets/{id}';

  /**
   * Update a single ShipperTarget.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOneBaseMgmtShipperTargetControllerShipperTarget()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtShipperTargetControllerShipperTarget$Response(params: UpdateOneBaseMgmtShipperTargetControllerShipperTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<ShipperTarget>> {
    const obs = updateOneBaseMgmtShipperTargetControllerShipperTarget(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a single ShipperTarget.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOneBaseMgmtShipperTargetControllerShipperTarget$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtShipperTargetControllerShipperTarget(params: UpdateOneBaseMgmtShipperTargetControllerShipperTarget$Params, context?: HttpContext): Observable<ShipperTarget> {
    const resp = this.updateOneBaseMgmtShipperTargetControllerShipperTarget$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShipperTarget>): ShipperTarget => r.body)
    );
  }

}
